import { Controller } from '@hotwired/stimulus'

// Reflète en direct la requête tapée (évènement search:query) dans le titre.
export default class extends Controller {
  static values = { default: String, template: String }

  update({ detail: { query } }) {
    this.element.textContent = query ? this.templateValue.replace('%{query}', query) : this.defaultValue
  }
}
